$(function() {
        function flicker() {
          var promoNew = '.promonew';
		if ($(promoNew).hasClass("noMore")) {
          // do nothing
          } else {
          $(promoNew).css('opacity', '0');
          setTimeout(function(){$(promoNew).css('opacity', '1')},500);
          setTimeout(function(){$(promoNew).addClass('noMore')},2500);
          setTimeout(flicker,1000);
        }}
        setTimeout(flicker,1000);
      });



      function closeDraw() {
        $(".sidebar-drawer__header-close").click();
      }